module.exports = __webpack_public_path__ + "img/dark-grey.0bc20f45.png";